import React from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  HStack,
  Heading,
  SkeletonText,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import EmptyState from "./EmptyState";

const SubscriptionInvoicesTable = ({
  invoices,
  isLoading,
  formatCurrency,
  formatDateTime,
  statusColor,
  onRefund,
}) => {
  const showRefund = typeof onRefund === "function";
  return (
    <Card variant="outline" _hover={{ boxShadow: "md" }} transition="box-shadow 0.2s ease">
      <CardHeader>
        <HStack justify="space-between">
          <Heading size="sm">Subscription Invoices</Heading>
          <Text fontSize="sm" color="gray.500">
            {invoices.length} records
          </Text>
        </HStack>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <SkeletonText noOfLines={6} spacing="3" />
        ) : invoices.length === 0 ? (
          <EmptyState title="No subscription invoices" description="Invoices will show up as subscriptions renew." />
        ) : (
          <TableContainer>
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th>External Invoice</Th>
                  <Th>Subscription</Th>
                  <Th>Customer</Th>
                  <Th isNumeric>Amount Paid</Th>
                  <Th>Status</Th>
                  <Th>Created</Th>
                  {showRefund ? <Th></Th> : null}
                </Tr>
              </Thead>
              <Tbody>
                {invoices.map((invoice) => (
                  <Tr key={invoice.id}>
                    <Td>{invoice.externalInvoiceId}</Td>
                    <Td>{invoice.stripeSubscriptionId || "-"}</Td>
                    <Td>{invoice.customerEmail}</Td>
                    <Td isNumeric>{formatCurrency(invoice.amountPaid, invoice.currency)}</Td>
                    <Td>
                      <Badge colorScheme={statusColor(invoice.status)}>{invoice.status}</Badge>
                    </Td>
                    <Td>{formatDateTime(invoice.createdDate)}</Td>
                    {showRefund ? (
                      <Td>
                        <Button
                          size="xs"
                          variant="outline"
                          colorScheme="orange"
                          isDisabled={String(invoice.status || "").toUpperCase() !== "PAID"}
                          onClick={() => onRefund(invoice)}
                        >
                          Refund
                        </Button>
                      </Td>
                    ) : null}
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </CardBody>
    </Card>
  );
};

export default SubscriptionInvoicesTable;
